import Layout from "../../layouts/default"

export const Audiences = () => {
    return <Layout>Audiences management...</Layout>
}